import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import { CreateChatMessageValidation } from 'types/chat.types';

export const getMessageFormValidationSchema = (
  validation: CreateChatMessageValidation
) => {
  const { text } = validation.properties;

  return yup.object({
    text: yup
      .string()
      .required('')
      .min(text.minLength, fieldValidationMessages.MIN_CHAR(text.minLength))
      .max(text.maxLength, fieldValidationMessages.MAX_CHAR(text.maxLength)),
  });
};
